import {WorkProposalLink} from './work-proposal-link';
import {Link} from 'react-router-dom';
import {useT} from '../lib/i18n';

type TabKey='overview'|'canvas'|'proposal'|'installation'|'documents'|(string&{});

type Props={
 active:TabKey;
 /** The Job's own sections, each a view of its own (Jacky, 4 October 2026: "move rest to tab with its own view"). Shown after Overview. */
 sections?:Array<{key:string;label:string;href:string}>;
 onNavigate?:(href:string)=>void;
 overviewHref:string;
 canvasHref?:string;
 onCanvas?:()=>void;
 canvasBusy?:boolean;
 proposalHref?:string;
 installationHref?:string;
 documentsHref?:string;
};

/** The work-level navigation stays the same while an Opportunity becomes a Job.
 * Site Canvas is deliberately beside Overview, never buried in Proposal or Installation. */
export function WorkTabs({active,sections=[],onNavigate,overviewHref,canvasHref,onCanvas,canvasBusy=false,proposalHref,installationHref,documentsHref}:Props){
 const {t}=useT();
 const tabs:Array<{key:TabKey;label:string;href?:string;action?:()=>void}>=[
  {key:'overview',label:t('workTabs.overview'),href:overviewHref},
  ...sections.map(s=>({key:s.key,label:s.label,href:s.href})),
  {key:'canvas',label:canvasBusy?t('workTabs.opening'):t('workTabs.canvas'),href:canvasHref,action:onCanvas},
 ];
 if(proposalHref)tabs.push({key:'proposal',label:t('workTabs.proposal'),href:proposalHref});
 if(installationHref)tabs.push({key:'installation',label:t('workTabs.installation'),href:installationHref});
 if(documentsHref)tabs.push({key:'documents',label:t('workTabs.documents'),href:documentsHref});
 const cls=(key:TabKey)=>`inline-flex min-h-11 items-center border-b-2 px-3 text-sm font-medium ${active===key?'border-primary text-foreground':'border-transparent text-muted-foreground hover:border-border hover:text-foreground'}`;
 return <><WorkProposalLink proposalHref={proposalHref}/><nav aria-label={t('workTabs.label')} className="mb-4 overflow-x-auto border-b" role="tablist">
  <div className="flex min-w-max gap-1">{tabs.map(tab=>tab.action
   ? <button key={tab.key} type="button" role="tab" aria-selected={active===tab.key} className={cls(tab.key)} disabled={canvasBusy} onClick={tab.action}>{tab.label}</button>
   : !tab.href ? <button key={tab.key} type="button" role="tab" aria-selected={active===tab.key} className={cls(tab.key)} disabled>{tab.label}</button> : <Link key={tab.key} role="tab" aria-selected={active===tab.key} className={cls(tab.key)} to={tab.href!} onClick={onNavigate?e=>{e.preventDefault();onNavigate(tab.href!)}:undefined}>{tab.label}</Link>)}</div>
 </nav></>;
}
